/**
 * Question List Component
 * Single Responsibility: Renders a list of question items
 */

import React from 'react';
import { spacing, strokeColors } from '@/design-system/utils';
import { QuestionItem } from './QuestionItem';

export interface QuestionListProps {
  questions: string[];
  onQuestionClick?: (question: string) => void;
}

/**
 * Question List Component
 * Displays a collection of question items
 */
export const QuestionList: React.FC<QuestionListProps> = ({
  questions,
  onQuestionClick,
}) => {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[0.5],
        width: '100%',
      }}
    >
      {questions.map((question, index) => (
        <React.Fragment key={`question-${index}`}>
          <QuestionItem question={question} onClick={onQuestionClick} />
          {index < questions.length - 1 && (
            <div
              style={{
                width: '100%',
                height: '1px',
                background: strokeColors.light,
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
